const company = {
  company: {
    pageHeader: 'Profil de la société',
    branchProfile: 'Profil de la succursale',
    addBranchOffice: 'Ajouter une agence',
    companyDetails: 'Détails de la société',
    branchDetails: 'Détails de la succursale',
    companyName: 'Nom de la société',
    branchName: 'Nom de la succursale',
    websiteURL: 'URL du site web',
    url: 'URL',
    yearFounded: 'Année de la fondation',
    companyLogo: 'Logo de la société',
    imageFormatDescription: 'Le fichier doit être un JPEG, GIF ou PNG inférieur à 4MB.',
    imageShapeDescription:
      'Pour de meilleurs résultats, nous vous recommandons une image carrée avec un fond transparent d’au moins 400px de large sur 400px de haut.',
    noFile: 'Aucun fichier sélectionné',
    companyDescription: 'Description de la société',
    myTestEdit: 'Modification de mon test',
    customerWelcomeEmail: 'Message de l’email de bienvenue du client',
    testEditMessage: 'message de l’email de modification du test',
    companyDescriptionTooltip:
      'Le texte saisi ici apparaîtra sur les vues publiques des systèmes installés par votre société. Vous pouvez souhaiter inclure les informations de contact pour permettre de générer des prospects à partir des visiteurs de ces pages.',
    editCompanyInformation: 'Modifier les informations de la société',
    welcomeEmailDescription:
      'Le texte saisi ici apparaîtra dans l’email de bienvenue envoyé aux nouveaux clients lorsqu’un compte Enlighten est créé. Vous pouvez choisir d’inclure le logo de votre société dans ce message.',
    editWelcomeMessage: 'Modifier le message de l’email de bienvenue du client',
    checkboxDisplayLogo: 'Afficher le logo de la société dans l’email de bienvenue du client',
    previewEmail: 'Aperçu de l’email de bienvenue du client',
    contactDetails: 'Coordonnées du contact',
    streetAddress: 'Adresse postale',
    streetAddress2: 'Adresse postale 2',
    city: 'Ville',
    zipCode: 'Code postal',
    customerSupport: 'Contacts de l’assistance clientèle',
    country: 'Pays',
    state: 'État/Province',
    contactOwnerDescription: 'que le propriétaire de système / le propriétaire peut contacter',
    businessContacts: 'Contacts professionnels',
    sameCheckbox: 'Identique à l’assistance clientèle',
    contactEnphaseDescription: 'qu’Enphase peut contacter',
    installationDetails: 'Service de l’entreprise',
    servicesOffered: 'Services proposés',
    installationType: 'Type d’installation',
    salesEmployeeNumber: 'Nombre d’employés dans la force de vente',
    workmanshipWarranty: 'Garantie d’installation (années)',
    installationEmployeeNumber: 'Nombre d’employés assurant les installations',
    typicalInstallationsYear: 'Nombre de d’installation (par an)',
    typicalInstallationsMonth: 'Puissance (KW/mois)',
    enphaseShare: 'Part d’Enphase dans les installations',
    sgipDeveloper: 'Êtes-vous développeur SGIP ?',
    sgipDeveloperTooltip: 'Sélectionnez cette option si vous êtes enregistré comme développeur SGIP sur selfgenca.com',
    fein_ein: 'FEIN/EIN',
    sgipDeveloperKey: 'Clé de développeur SGIP',
    businessLicenses: 'Certificats',
    addNewLicense: 'AJOUTER UNE QUALIFICATION',
    licenseType: 'Qualification',
    licenseNo: 'Numéro de certificat',
    none: 'Aucune',
    licensingBoard: 'Organisme accréditeur',
    licensingAuthority: 'Autorité des licences',
    expiryDate: 'Date d’expiration',
    profileLinks: 'Liens du profil',
    yelpAccountLink: 'Lien du compte Yelp',
    rating: 'Note: ',
    reviews: 'Critiques: ',
    yelpAccountLinkTooltip:
      'Pour obtenir ce lien, allez sur votre profil Yelp et copiez le lien/URL dans la barre d’adresse de votre navigateur',
    yelpAccountLinkError:
      'Nous ne sommes pas parvenus à retrouver votre profil Yelp. Veuillez vérifier le lien du profil que vous avez saisi',
    googlePlaceId: 'adresse google',
    clickHere: 'Cliquez ici',
    findPlaceId: 'pour trouver votre adresse google',
    placeIdError:
      'Nous ne sommes pas parvenus à trouver une localisation valide pour cet identifiant. Veuillez vérifier à nouveau l’identifiant que vous avez saisi.',
    solarProfileLink: 'Lien du profil SolarReviews',
    solarProfileLinkTooltip:
      'Pour obtenir ce lien, allez sur votre profil SolarReviews.com et copiez le lien/URL dans la barre d’adresse de votre navigateur',
    bbbProfileLink: 'Lien du profil BBB',
    bbbProfileLinkTooltip:
      'Pour obtenir ce lien, allez sur votre profil BBB.org et copiez le lien/URL dans la barre d’adresse de votre navigateur',
    solarQuotesProfileLink: 'Lien du profil Solarquotes',
    solarQuotesTooltip:
      'Pour obtenir ce lien, allez sur votre profil solarquotes.com et copiez le lien/URL dans la barre d’adresse de votre navigateur',
    productReviewProfileLink: 'Lien du profil ProductReview',
    productReviewTooltip:
      'Pour obtenir ce lien, allez sur votre profil productreview.com et copiez le lien/URL dans la barre d’adresse de votre navigateur',
    trustPilotLink: 'Lien du profil Trustpilot',
    trustPilotTooltip:
      'Pour obtenir ce lien, allez sur votre profil trustpilot.com et copiez le lien/URL dans la barre d’adresse de votre navigateur',
    facebookLink: 'Lien du profil Facebook',
    facebookTooltip:
      'Pour obtenir ce lien, allez sur votre profil facebook.com et copiez le lien/URL dans la barre d’adresse de votre navigateur',
    justDialLink: 'Lien du profil Just Dial Profile',
    justDialTooltip:
      'Pour obtenir ce lien, allez sur votre profil justdial.com et copiez le lien/URL dans la barre d’adresse de votre navigateur',
    listOfReferenceSystems: 'Liste des systèmes de référence',
    referenceListDescription:
      'Votre liste de référence se met à jour automatiquement pour présenter les systèmes que les propriétaires ont choisi de partager. Les systèmes listés ont au moins 100kWh d’énergie sur leur durée de vie',
    requestSystemAccess: 'Demander l’accès au système',
    maintainer: 'Mainteneur',
    view_only: 'Visualisation seulement',
    linkRequestAccess:
      'Envoyer ce lien aux propriétaires de système pour demander l’accès à leur système sur Enlighten',
    fieldRequired: 'Ce champ est requis.',
    validEmail: 'Veuillez saisir une adresse email valide.',
    validPhone: 'Veuillez saisir un numéro de téléphone valide.',
    supportContact: 'Veuillez remplir au moins l’un des champs ci-dessus (Téléphone/Email).',
    serviceRequired: 'Au moins un type de service est requis',
    installationRequired: 'Au moins un type d’installation est requis',
    minLength: 'La longueur minimum permise est de 2',
    maxLength: 'La longueur maximum permise est de 15',
    dateWarning:
      'Avertissement : Cette licence sera considérée comme expirée puisque la date d’expiration est dépassée',
    correctValue: 'Veuillez saisir une valeur inférieure ou égale à\xa0',
    feinLength: 'Veuillez saisir un nombre à 9 chiffres',
    less_than_25: 'Inférieur à 25 %',
    between_25_50: '25 % à 50 %',
    between_50_90: '50 % à 90 %',
    greater_than_90: 'Plus de 90 %',
    roofing: 'Toiture',
    solar: 'Photovoltaïque',
    storage: 'Stockage',
    electrical: 'Electricité',
    ev_charger: 'Chargeur EV',
    others: 'Autres',
    commercial: 'Tertiaire',
    residential: 'Residentiel',
    new_homes: 'constructions neuves',
    installer: 'Installateur',
    roles_distributor: 'Distributeur',
    roles_support: 'Société d’assistance',
    cec: 'CEC',
    electrical_contract: 'Contrat d’électricité',
    abn_number: 'Numéro ABN',
    acn_number: 'Numéro ACN',
    installateurverzeichniss_elektro_eintrag: 'Installateurverzeichniss Elektro Eintrag',
    sgze: 'SGZE',
    zonnekeur: 'Zonnekeur',
    holland_solar: 'Holland Solar',
    techniek_nederland: 'Techniek Nederland',
    installq: 'InstallQ',
    fedelec: 'Fedelec',
    pv_vlaanderen: 'PV Vlaanderen',
    selectCountry: 'Veuillez sélectionner le pays',
    yellowPageLink: 'Lien Page jaune',
    yellowPageTooltip: `Pour obtenir ce lien, allez sur votre profil https://www.pagesjaunes.fr/ et copiez le lien / URL dans la barre d’adresse de votre navigateur Internet.`,
    enrQualityDirectoryLink: 'Annuaire Qualit’Enr',
    enrQualityDirectoryTooltip: `Pour obtenir ce lien, allez sur votre profil https://www.qualit-enr.org/annuaire/ et copiez le lien / URL dans la barre d’adresse de votre navigateur Internet.`,
    validChamberNumber: 'Entrée invalide! Minimum 8 caractères requis pour le numéro de chambre de commerce',
    chamberofcommerce : 'Numéro de chambre de commerce',
  }
};

export default company;
